import type { FormValues, MockItem } from '@preview/types';
import { getDataTypeGuard } from '../getDataTypeGuard';

const determineMockType = (mock: MockItem): FormValues['mockType'] => {
  const { data, endpoint } = mock;

  const { hasFeeds, hasPlaylists, hasVideos } = getDataTypeGuard(data);

  if (endpoint.includes('channels')) {
    return 'channel';
  } else if ((endpoint.includes('sites') || endpoint.includes('feed')) && hasFeeds) {
    return 'feed';
  } else if (endpoint.includes('playlists') && hasVideos) {
    return 'playlist';
  } else if (endpoint.includes('videos') && hasPlaylists) {
    return 'video';
  }

  return 'other';
};

export default determineMockType;
